import { IUserShort } from '@spa/data/entities';
import { Observable } from 'rxjs';

export abstract class SignaturesHttpService {
	abstract getQuickReplies(taskId: number | string): Observable<string[]>;
	abstract changeSignatureDueDate(obj: ISignatureDueDateChangeCriteria): Observable<any>;
	abstract addQuickReply(obj: IAddQuickReplyCriteria): Observable<any>;
	abstract getDynamicSignatures(taskId: number): Observable<IGetDynamicSignatureResult>;
	abstract getDynamicSignaturesByUser(taskId: number, userId: string): Observable<IGetDynamicSignaturesByUserResult>;
	abstract requestDynamicUserSignature(obj: IRequestDynamicUserSignature): Observable<any>;
	abstract requestDynamicSignature(obj: IRequestDynamicSignature): Observable<any>;
	abstract getPossibleAcceptants(taskId: number, signatureId: number): Observable<IUserShort[]>;
	abstract getSignaturesById(id: number): Observable<any>;
	abstract revokeTaskSignatures(params: IRevokeTaskSignaturesParams): Observable<any>;
	abstract addUnrequiredSignatures(obj: IAddUnrequiredSignatures): Observable<any>;
	abstract changeTaskStepWithoutUnrequiredSignatures(taskId: number): Observable<any>;
}

export interface IRevokeTaskSignaturesParams {
	reason: string;
	taskId: number;
	location?: any;
}

export interface ISignatureDueDateChangeCriteria {
	location?: any;
	newDate: string;
	reason: string;
	taskSignatureId: number;
}
export interface IAddQuickReplyCriteria {
	reason: string;
}

export interface IAcceptorsArr {
	Users: number[];
	Groups: number[];
	OrgUnits: number[];
	Unresolved: any[];
	IsEmpty: boolean;
}

export interface IRequestDynamicUserSignature {
	taskId: number;
	reason: string;
	due: number;
	acceptorsArr: IAcceptorsArr;
	separateForEach: boolean;
}

export interface IRequestDynamicSignature {
	signatureId: string;
	taskId: number;
	reason: string;
	due: number;
}

export interface IGetDynamicSignatureResultObj {
	__type: string;
	name: string;
	value: string;
	isDefaultValue: boolean;
	optionTitle?: any;
}

export interface IGetDynamicSignatureResult {
	d: IGetDynamicSignatureResultObj[];
}
export interface IGetDynamicSignaturesByUserD {
	signName: string;
	signatures: IGetDynamicSignatureResult[];
}
export interface IGetDynamicSignaturesByUserResult {
	d: IGetDynamicSignaturesByUserD;
}

export interface IAddUnrequiredSignatures {
	SignaturesList: number[];
	taskId: number;
}
